module.exports = __webpack_public_path__ + "static/media/hearth-o.ca5c8a0f.svg";